/** Shared HTTP-error detail extraction, so consoleApi + adminApi surface backend
 *  `{detail: …}` errors identically and can't drift. */
export async function readErrorDetail(res: Response, fallback: string): Promise<string> {
  try {
    const body = (await res.json()) as { detail?: string };
    if (body?.detail) return body.detail;
  } catch {
    /* non-JSON error body — keep the fallback */
  }
  return fallback;
}
